import type { TFunction } from 'i18next';

import { minPecaLabel, razaoMotorFabrica, resolveVeredito } from '@/components/explica/veredito';
import type { FilaDesvioExplicacao, FilaItem } from '@/domain/fila/interfaces/fila';

/**
 * The deviation parts of the item, when it has them: the reason only carries them on
 * DESVIO, which is also the only reason that is a comparison between two times.
 */
export function desvioDoItem(item: FilaItem): FilaDesvioExplicacao | null {
  const motivos = item.motivos ?? [];
  return motivos.find((motivo) => motivo.desvio !== null)?.desvio ?? null;
}

/**
 * The same verdict on ONE line, for a surface with no room for the chip and the (i)
 * (the home preview of the queue). Same words and same two times as the queue itself:
 * a percentage is never what the reader needs.
 */
export function desvioFraseCurta(t: TFunction, desvio: FilaDesvioExplicacao): string | null {
  const veredito = resolveVeredito(
    razaoMotorFabrica(desvio.minPecaVigente, desvio.minPecaRealizado),
    desvio.tolerancia,
  );
  const motor = minPecaLabel(desvio.minPecaVigente);
  const fabrica = minPecaLabel(desvio.minPecaRealizado);
  if (veredito === null || motor === null || fabrica === null) {
    return null;
  }
  return `${t(`explica.veredito.${veredito}`)}: ${t('explica.tempos', { motor, fabrica })}`;
}
